import { createFileRoute } from '@tanstack/react-router';
import { MembersPage } from '@/features/settings/MembersPage';

export const Route = createFileRoute('/app/settings/members')({
  component: MembersPage,
  staticData: { title: 'Members · Settings' },
});
